
import { Prop, Vue, Component, Emit } from 'vue-property-decorator'
import { IReporterCollection } from '@/types/reporter-types'
import { IMG_HOST } from '@/config/env'
import { ReporterService } from '@/services/index'

@Component
export default class extends Vue {
    @Prop({ type: Array, default: () => [], required: true }) data!: Array<IReporterCollection>
    private IMG_HOST = IMG_HOST

    @Emit('edit')
    private handleEdit(item: IReporterCollection): IReporterCollection {
        return item
    }

    @Emit('remove')
    private handleRemove(id: number): number {
        return id
    }

    // 导航到集合详情页
    private async handleNavigate(id: number) {
        try {
            // 先验证数据是否可访问
            const loading = this.$loading({
                lock: true,
                text: '加载中...'
            })
            
            // 尝试获取集合详情，验证数据
            const result = await ReporterService.getReporterCollectionDetail({ id })
            
            loading.close()
            
            if (result.status === 200) {
                this.$router.push(`/reporter/collection/${id}`)
            } else {
                this.$message.error(result.message || '数据获取失败')
                console.error('数据验证失败:', result.message)
            }
        } catch (error) {
            console.error('导航失败:', error)
            this.$message.error('导航失败，请稍后重试')
        }
    }
}
